import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import {Location} from '@angular/common';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {catchError, forkJoin, of} from 'rxjs';

@Component({
    selector: 'app-review-users',
    templateUrl: './review-users.component.html',
    styleUrls: ['./review-users.component.css'],
    standalone: false
})
export class ReviewUsersComponent implements OnInit {

  userId = '';
  parameters: any[] = [];
  posts: any[] = [];
  hypocrisies: any[] = [];
  user: any = null;
  loading = true;
  activeTab: 'reviews' | 'posts' | 'hypocrisy' = 'reviews';
  selectedReview: any = null;
  modalRef?: BsModalRef;
  readonly ratingLabels = ['Hindu', 'Christian', 'Muslim'];

  constructor(private route: ActivatedRoute,
              private dashboardService: DashboardService,
              private _location: Location,
              private modalService: BsModalService) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.userId = params["id"]);
    this.getReviews();
  }

  getReviews(): void {
    this.loading = true;
    forkJoin({
      reviews: this.dashboardService.getRatingsByUser(this.userId).pipe(catchError(() => of([]))),
      user: this.dashboardService.getUserDataById(this.userId).pipe(catchError(() => of(null))),
      timeline: this.dashboardService.getUserTimeline(this.userId).pipe(catchError(() => of(null)))
    }).subscribe(({reviews, user, timeline}: any) => {
      this.parameters = Array.isArray(reviews) ? reviews : (reviews?.response || []);
      this.user = user?.response || user || this.parameters[0]?.user || {};

      const activity = timeline?.response?.timeline || timeline?.timeline || [];
      this.posts = activity.filter((item: any) => item.type === 'story');
      this.hypocrisies = activity.filter((item: any) => item.type === 'hypocrisy');
      this.loading = false;
    });
  }

  remove(id: string, i): void {
    this.dashboardService.deleteRatings(id).subscribe((data) => {
      this.parameters.splice(i, 1);
    });
  }

  openReviewModal(review: any, template: TemplateRef<any>): void {
    this.selectedReview = review;
    this.modalRef = this.modalService.show(template, {
      class: 'modal-lg modal-dialog-centered'
    });
  }

  goBack(): void {
    this._location.back();
  }

  getUserName(): string {
    const fullName = this.user?.fullName?.trim();
    const composedName = [this.user?.firstName, this.user?.lastName].filter(Boolean).join(' ').trim();
    return fullName || composedName || this.user?.username || this.user?.email || 'User';
  }

  getUserInitials(): string {
    return this.getUserName().split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase();
  }

  getUserAvatar(): string {
    return this.user?.profile || this.user?.image || this.user?.avatar || '';
  }

  getMediaUrl(media: any): string {
    if (!media) {
      return '';
    }
    if (typeof media === 'string') {
      return media;
    }
    return media.url || media.location || media.secure_url || '';
  }

  isVideo(media: any): boolean {
    const url = this.getMediaUrl(media).toLowerCase();
    const mediaType = `${media?.type || media?.mimeType || ''}`.toLowerCase();
    return mediaType.includes('video') || /\.(mp4|webm|mov|m4v)(\?|$)/.test(url);
  }

  getEntityName(item: any): string {
    const entity = item?.entity;
    return entity?.entityName
      || [entity?.firstName, entity?.lastName].filter(Boolean).join(' ')
      || entity?.name
      || 'General';
  }
}
